import { SxProperties } from '@bvi/mui-theme';

export const styles = {
  wrapper: {
    paddingLeft: 3,
    paddingRight: 3,
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  caseHadingBoxWrapper: {
    backgroundColor: '#fdebc3',
    padding: '0px 10px',
    borderRadius: '5px',
    boxShadow: '1px 3px 4px rgba(0, 0, 0, 0.15)',
  },
  filterFieldColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  filterFieldExcludeRow: {
    minHeight: 36,
    display: 'flex',
    alignItems: 'center',
    mt: 0.5,
  },
  orgRow: {
    alignItems: 'flex-start',
  },
  orgRowSubmit: {
    display: 'flex',
    alignItems: 'flex-start',
    pt: 1,
  },
} satisfies SxProperties;
